import React, { FunctionComponent } from 'react';
import MUIIconButton, { IconButtonProps as MUIIconButtonProps } from '@material-ui/core/IconButton';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { palettes } from '@indigo-ag/component-module';

export enum IconButtonStatus {
  ACTIVE = 'ACTIVE',
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  DISABLED = 'DISABLED'
}

export const iconButtonStatusColorsMap: {
  [key in IconButtonStatus]: string;
} = {
  ACTIVE: palettes.coastal.core.mediumBlue,
  POSITIVE: palettes.coastal.accent.green,
  NEGATIVE: palettes.coastal.accent.orange,
  DISABLED: palettes.neutral[400]
};

export interface IconButtonProps extends MUIIconButtonProps {
  /** Name of the icon to use */
  icon?: IconDefinition;
  /** Name attribute for button element */
  name?: string;
  /** Status of the icon to set the correspondent color */
  status?: IconButtonStatus;
}

export const IconButton: FunctionComponent<IconButtonProps> = ({
  icon,
  name,
  status = IconButtonStatus.ACTIVE,
  children,
  ...rest
}) => {
  return (
    <MUIIconButton {...rest} name={name}>
      {icon ? <FontAwesomeIcon icon={icon} color={iconButtonStatusColorsMap[status]} /> : children}
    </MUIIconButton>
  );
};
